// SPDX-FileCopyrightText: 2024 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { isString } from "@sequentech/ui-core";
import { setBallotStyle } from "../store/ballotStyles/ballotStylesSlice";
import { resetBallotSelection } from "../store/ballotSelections/ballotSelectionsSlice";
export var updateBallotStyleAndSelection = function (data, dispatch) {
    for (var _i = 0, _a = data.sequent_backend_ballot_style; _i < _a.length; _i++) {
        var ballotStyle = _a[_i];
        var ballotEml = ballotStyle.ballot_eml;
        if (!isString(ballotEml)) {
            continue;
        }
        try {
            var electionData = JSON.parse(ballotEml);
            var formattedBallotStyle = {
                id: ballotStyle.id,
                election_id: ballotStyle.election_id,
                election_event_id: ballotStyle.election_event_id,
                tenant_id: ballotStyle.tenant_id,
                ballot_eml: electionData,
                ballot_signature: ballotStyle.ballot_signature,
                created_at: ballotStyle.created_at,
                area_id: ballotStyle.area_id,
                annotations: ballotStyle.annotations,
                labels: ballotStyle.labels,
                last_updated_at: ballotStyle.last_updated_at,
            };
            dispatch(setBallotStyle(formattedBallotStyle));
            dispatch(resetBallotSelection({
                ballotStyle: formattedBallotStyle,
                force: true,
            }));
        }
        catch (error) {
            console.log("Error loading EML: ".concat(error));
            console.log(ballotEml);
            throw error;
        }
    }
};
